import { ApiResponse } from '@/utils';
import { enhancedRequest } from '@/utils/enhancedRequest';
import {
  CreateGroupParams,
  CreateGroupResponse,
  GetGroupListParams,
  GroupListResponse,
  RenameGroupParams,
  DeleteGroupParams,
} from '../types';

/**
 * AMAI分组管理服务
 * 用于创建和管理分组，支持文档分组和项目分组
 */
class GroupService {
  /**
   * 创建新分组（带防重复请求）
   * @param params 创建参数 {name, type}
   * @returns 创建结果，返回 group_id
   */
  async createGroup(params: CreateGroupParams): Promise<ApiResponse<CreateGroupResponse>> {
    return enhancedRequest.post<CreateGroupResponse>('/group', params, {
      enableDeduplication: true,
      requestKey: `group-create:${JSON.stringify(params)}`,
      retryCount: 1,
    });
  }

  /**
   * 获取分组列表（带防重复请求和缓存）
   * @param params 查询参数 {type}，type: 1=文档分组, 2=项目分组
   * @returns 分组列表
   */
  async getGroupList(params: GetGroupListParams): Promise<ApiResponse<GroupListResponse>> {
    return enhancedRequest.post<GroupListResponse>('/group/list', params, {
      useCache: true,
      cacheTTL: 5 * 60 * 1000, // 分组列表缓存5分钟
      enableDeduplication: true,
      requestKey: `group-list:${JSON.stringify(params)}`,
      retryCount: 2,
    });
  }

  /**
   * 分组重命名（带防重复请求）
   * @param params 请求参数 { group_id, name }
   * @returns 操作结果
   */
  async renameGroup(params: RenameGroupParams): Promise<ApiResponse<null>> {
    return enhancedRequest.post<null>('/group/rename', params, {
      enableDeduplication: true,
      requestKey: `group-rename:${JSON.stringify(params)}`,
      retryCount: 1,
    });
  }

  /**
   * 删除分组（带防重复请求）
   * @param params 请求参数 { group_id }
   * @returns 操作结果
   */
  async deleteGroup(params: DeleteGroupParams): Promise<ApiResponse<null>> {
    return enhancedRequest.post<null>('/group/delete', params, {
      enableDeduplication: true,
      requestKey: `group-delete:${params.group_id}`,
      retryCount: 1,
    });
  }
}

export default new GroupService();
